import { useEffect, useState, useSyncExternalStore } from 'react';

import { IS_APPLE } from 'src/helpers/environment';

const SHOW_DELAY_MS = 20;

export function useMobileSheet(): { shown: boolean } {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShown(true), SHOW_DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  return { shown };
}

export function useMobileSheetViewportWidth(): number {
  return useSyncExternalStore(subscribeViewportWidth, getViewportWidthSnapshot);
}

export function useMobileSheetKeyboardInset(): number {
  return useSyncExternalStore(subscribeKeyboardInset, getKeyboardInsetSnapshot);
}

function subscribeViewportWidth(notify: () => void): () => void {
  const vv = window.visualViewport;
  vv?.addEventListener('resize', notify);
  window.addEventListener('resize', notify);
  return () => {
    vv?.removeEventListener('resize', notify);
    window.removeEventListener('resize', notify);
  };
}

function getViewportWidthSnapshot(): number {
  return window.visualViewport?.width ?? window.innerWidth;
}

function subscribeKeyboardInset(notify: () => void): () => void {
  if (IS_APPLE) return () => {};
  const vv = window.visualViewport;
  if (!vv) return () => {};
  vv.addEventListener('resize', notify);
  vv.addEventListener('scroll', notify);
  return () => {
    vv.removeEventListener('resize', notify);
    vv.removeEventListener('scroll', notify);
  };
}

function getKeyboardInsetSnapshot(): number {
  if (IS_APPLE) return 0;
  const vv = window.visualViewport;
  if (!vv) return 0;
  const covered = window.innerHeight - vv.height - vv.offsetTop;
  return Math.max(0, Math.round(covered));
}
